// Copie locale, en clair, de la liste des enfants attendus : permet de la rouvrir pour
// la compléter. Limitée à ce navigateur ; effacée 7 jours après la fin du séjour.
const PREFIX = 'expected_list:';
const RETENTION_MS = 7 * 24 * 3600 * 1000;

export function loadLocal(unitId) {
    try {
        const raw = localStorage.getItem(PREFIX + unitId);
        return raw ? JSON.parse(raw) : null;
    } catch { return null; }
}

export function saveLocal(unitId, data) {
    try { localStorage.setItem(PREFIX + unitId, JSON.stringify(data)); return true; }
    catch { return false; }
}

export function forgetLocal(unitId) {
    try { localStorage.removeItem(PREFIX + unitId); } catch { /* stockage indisponible */ }
}

export function purgeExpired(nowMs = Date.now()) {
    try {
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (!key || !key.startsWith(PREFIX)) continue;
            const end = Date.parse(`${loadLocal(key.slice(PREFIX.length))?.unitEndDate}T23:59:59Z`);
            if (!Number.isNaN(end) && nowMs > end + RETENTION_MS) localStorage.removeItem(key);
        }
    } catch { /* stockage indisponible */ }
}
